export default `.ids-hierarchy-item {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-inline-start: calc(var(--ids-space-xs) * 12);
}
@media all and (max-width: 767px) {
  .ids-hierarchy-item {
    padding-inline-start: var(--ids-space-none);
  }
}

.leaf {
  border: var(--ids-space-4xs) solid var(--ids-hierarchy-item-leaf-color-border);
  margin-block-end: calc(var(--ids-space-xs) * 4);
  box-shadow: var(--ids-hierarchy-item-leaf-shadow);
  border-radius: var(--ids-hierarchy-item-border-radius);
  position: relative;
  width: 315px;
}
.leaf::before {
  display: block;
  position: absolute;
  border-bottom: 1.34px solid var(--ids-hierarchy-item-leaf-before-color-border);
  border-inline-start: 1.34px solid var(--ids-hierarchy-item-leaf-before-color-border);
  content: "";
  height: 115px;
  inset-inline-start: -30px;
  top: -70px;
  width: 50%;
  z-index: 0;
}

.leaf-inside {
  align-items: center;
  background-color: var(--ids-hierarchy-item-color-background);
  border-inline-start: var(--ids-hierarchy-item-leaf-inside-border-left);
  box-shadow: var(--ids-hierarchy-item-leaf-inside-shadow);
  padding: var(--ids-space-xs) calc(var(--ids-space-xs) * 2);
  position: relative;
  display: flex;
  z-index: 1;
}

.avatar {
  flex-shrink: 0;
  display: block;
  height: 55px;
  width: 55px;
  border: var(--ids-hierarchy-item-border-default);
  border-radius: 100%;
  margin-inline-end: calc(var(--ids-space-xs) * 2);
  overflow: hidden;
}
.avatar ::slotted(img) {
  max-width: 100%;
}

:host([root-item]) .leaf::before {
  display: none;
}
:host([root-item]) .ids-hierarchy-item {
  padding-inline-start: var(--ids-space-none);
}

@media all and (max-width: 767px) {
  :host([root-item][expanded]) .leaf::before {
    border-inline-start: none;
    display: block;
  }
}

:host(:focus) {
  outline: none;
  border: none;
  border-color: var(--ids-color-transparent);
  box-shadow: var(--ids-hierarchy-item-shadow-focus);
}

:host([selected]) .leaf {
  box-shadow: var(--ids-hierarchy-item-selected-leaf-shadow);
}

div[part=actions] {
  margin-inline-start: auto;
  display: flex;
}

ids-button[part=icon-menu] {
  margin-inline-end: var(--ids-space-2xs);
}
ids-button[part=icon-menu] .ids-icon-button {
  padding: var(--ids-space-2xs);
}

ids-button[part=icon-btn] {
  display: none;
  cursor: pointer;
}
ids-button[part=icon-btn] .ids-icon-button {
  padding: var(--ids-space-2xs);
}

:host([expanded]) ids-button[part=icon-btn] ids-icon {
  transform: rotate(180deg);
}

.has-nested-items ids-button[part=icon-btn] {
  display: block;
}

.sub-level {
  display: none;
}

:host([expanded]) .sub-level {
  display: block;
}

::slotted([slot=menu]) {
  position: relative;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
